<form class="form-horizontal" #form="ngForm" (ngSubmit)="onSubmit()">

  <div class="form-group">
    <label class="control-label col-sm-3">{{ 'Exception type' | translate }}:</label>
    <div class="col-sm-9">
      <select class="form-control" name="exceptionType" [(ngModel)]="assistanceTicket.exception_type" required [disabled] = "parseToBoolean(assistanceTicket.id)">
        <option *ngFor="let et of exceptionsType" [ngValue]="et.id">{{ et.name | translate }}</option>
      </select>
    </div>
  </div>  
  <div class="form-group">
    <label class="control-label col-sm-3">{{ 'Supervisor Confirm' | translate }}:</label>
    <div class="col-sm-9">
      <select class="form-control" name="type" [(ngModel)]="assistanceTicket.supervisor_id" required [disabled] = "parseToBoolean(assistanceTicket.id)">
        <option *ngFor="let supervisor of supervisors" [ngValue]="supervisor.id">{{ supervisor.name }}</option>
      </select>
    </div>
  </div>
  <div class="form-group">
    <label class="control-label col-sm-3">{{ 'Comment' | translate }}:</label>
    <div class="col-sm-9">
        <textarea rows="5" cols="10" class="form-control" [(ngModel)]="assistanceTicket.comment" name="comment" required [disabled] = "parseToBoolean(assistanceTicket.id)"> 
        </textarea>
    </div>
  </div>
  <div class="form-group">
    <div class="col-sm-offset-3 col-sm-9 div-btn-right">
      <button type="submit" class="btn btn-primary btn-sm btn-right" [disabled]="form.form.invalid || form.form.pending || isDisabled || assistanceTicket.id">
        {{ 'Save' | translate }}
      </button>
      <button type="button" class="btn btn-default btn-sm btn-right" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
    </div>
  </div>
</form>
